module.exports = __webpack_public_path__ + "img/icb-empty-m@2x.443a6466.png";